export default class GoogleMap {
    constructor(element) {
      this.$element = $(element);
      this.map = null;
    }
  
    static initAll(selector = '.c-map') {
      if (!window.google || !window.google.maps) {
        // cancel if google maps is not present
        return;
      }
  
      $(selector).each(function () {
        const map = new GoogleMap(this);
  
        map.init();
      });
    }
  
    init() {
      const $markers = this.$element.find('.marker');
      const mapArguments = {
        zoom: 16,
        center: new window.google.maps.LatLng(0, 0),
        mapTypeId: window.google.maps.MapTypeId.ROADMAP,
      };
  
      this.map = new window.google.maps.Map(this.$element[0], mapArguments);
      this.map.markers = [];
  
      $markers.each((index, element) => {
        this.addMarker($(element));
      });
      this.centerMap();
    }
  
    addMarker($marker) {
      const marker = new window.google.maps.Marker({
        position: new window.google.maps.LatLng(
          $marker.attr('data-lat'),
          $marker.attr('data-lng')
        ),
        map: this.map,
      });
  
      this.map.markers.push(marker);
  
      // if marker contains HTML, add it to an infoWindow
      if ($marker.html()) {
        const infowindow = new window.google.maps.InfoWindow({
          content: $marker.html(),
        });
  
        window.google.maps.event.addListener(marker, 'click', () => {
          infowindow.open(this.map, marker);
        });
      }
    }
  
    centerMap() {
      const bounds = new window.google.maps.LatLngBounds();
  
      // loop through all markers and create bounds
      $.each(this.map.markers, (i, marker) => {
        const latlng = new window.google.maps.LatLng(
          marker.position.lat(),
          marker.position.lng()
        );
  
        bounds.extend(latlng);
      });
  
      // only 1 marker?
      if (this.map.markers.length === 1) {
        // set center of map
        this.map.setCenter(bounds.getCenter());
        this.map.setZoom(16);
      } else {
        // fit to bounds
        this.map.fitBounds(bounds);
      }
    }
  }
  


// WEBPACK FOOTER //
// ./scripts/blocks/googleMap.js